@if (showLoader) {
  <div class="width-6 loader-wrapper">
    <div class="loader"></div>
  </div>
}
